/**
 * LEGACY COMPOSABLE - Delegates to useExtraPacksStore
 * 
 * This composable is kept for backward compatibility but now uses the new
 * route-aware store to prevent global loading of extra packs data.
 */
export function useExtraPacksMore() {
  const route = useRoute();
  const extraPacksStore = useExtraPacksStore();
  
  // Use the store's state
  const extraPacksMore = computed(() => extraPacksStore.extraPacksMore);
  
  /**
   * Modified to be route-aware and only fetch on relevant routes
   */
  const fetchExtraPacksMore = async () => {
    // Check if we're on a relevant route
    const isRelevantRoute = 
      route.path.startsWith('/extra-packs') || 
      (route.path.startsWith('/account/dashboard') && route.query.view === 'extra-roaming');
    
    // Only fetch if on a relevant route
    if (isRelevantRoute) {
      console.log('[useExtraPacksMore] On relevant route, delegating to store');
      return extraPacksStore.getDetailedExtras();
    } else {
      console.log('[useExtraPacksMore] Not on relevant route, skipping fetch');
      return extraPacksStore.extraPacksMore;
    }
  };

  return {
    extraPacksMore,
    fetchExtraPacksMore,
  };
}
